// //final
import React, { useEffect, useRef, useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import Footer from "../Footer";
import "animate.css/animate.min.css";
import Header from "../Header";
import { useForm } from "react-hook-form";
import { apiCall, googleMapsApiKey } from "../util";
import axios from "axios";
import anime from "animejs";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contact_booking, contact_career, contact_emergency, contact_location, logofloating, quotes, why_choose_section_bg } from "../Image";
import { setTopSpaceHeight } from "../custom";
import { useData } from "../../context/DataContext";
const ContactUs = () => {
  const cardRef = useRef(null);
  const titleRef = useRef(null);
  const data = useData();
  // console.log(data, "data");
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm(); // Hook to manage the form state
  const [loading, setLoading] = useState(false);
  const [showToastContainer, setShowToastContainer] = useState(false);
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const response = await axios.post(apiCall + "contact-us", data);

      if (
        response.data &&
        response.data.message === "Form submitted successfully!"
      ) {
        reset();
        setShowToastContainer(true);
        toast.success("Feedback sent successfully!", {
          onClose: () => setShowToastContainer(false),
        });
      } else {
        toast.error("Something went wrong. Please try again!");
      }
    } catch (error) {
      // Show error toast notification
      toast.error("Error submitting form!");

      console.error("Error submitting form:", error);
    } finally {
      // Stop loading after request completion
      setLoading(false);
    }
  };
useEffect(() => {
    if (typeof setTopSpaceHeight === "function") {
      setTopSpaceHeight();
    }
  }, []);

  useEffect(() => {
    if (titleRef.current) {
      anime({
        targets: titleRef.current.children,
        opacity: [0, 1],
        translateX: [-30, 0],
        duration: 800,
        delay: 0,
        easing: "easeOutQuad",
        stagger: 300, // Stagger animation for each child element
      });
    }
    // Card animation (for contact boxes)
    if (cardRef.current) {
      anime({
        targets: cardRef.current.children,
        translateY: [30, 0],
        opacity: [0, 1],
        duration: 600,
        delay: 0,
        easing: "easeOutQuad",
        stagger: 300,
      });
    }
  }, []);
  return (
    <>
      <Header />

      <section className="top-space-margin position-relative pt-60px pb-60px page-title-big-typography bg-sg-light-gradient -bg-base-color-light">
        <img src={logofloating} className="floating-logo" alt="floating-logo" />
        <div className="container">
          <div className="row -extra-very-small-screen align-items-center">
            <div
              className="col-lg-6 col-sm-8 position-relative page-title-extra-small"
              ref={titleRef}
            >
              <h1 className="mb-20px xs-mb-20px text-dark-gray text-shadow-medium">
                <span className="w-30px h-2px bg-base-color d-inline-block align-middle position-relative top-minus-2px me-10px"></span>
                Contact us
              </h1>
              <h4 className="text-dark-gray text-shadow-medium fw-bold ls-minus-2px mb-0">
                Redefining Your{" "}
                <span className="text-gradient-sg-red-purple ">
                  Healthcare Experience
                </span>
              </h4>
            </div>
          </div>
        </div>
      </section>

      <section className="sg-li bg-white half-section">
        <div className="container">
          <div
            className="row justify-content-center gy-4"
            ref={cardRef} // Reference for the cards animation
          >
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
                <div className="mb-15px">
                  <img
                    src={contact_emergency}
                    className="h-60px -w-100 object-fit-cover"
                    alt=""
                  />
                </div>
                <h5 className="fs-18 fw-bold mb-10px text-dark-gray m-0 lh-sm">
                  Emergency Contact
                </h5>
                <p className="fs-14 m-0 lh-base">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga
                  labore pariatur aspernatur.
                </p>
                <a
                  href="tel:+914742720000"
                  className="btn btn-sm btn-gradient-sg-header px-4 mt-15px rounded-pill fw-600"
                >
                  Call now
                </a>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
                <div className="mb-15px">
                  <img
                    src={contact_location}
                    className="h-60px -w-100 object-fit-cover"
                    alt=""
                  />
                </div>
                <h5 className="fs-18 fw-bold mb-10px text-dark-gray m-0 lh-sm">
                  Our Location
                </h5>
                <p className="fs-14 m-0 lh-base">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga
                  labore pariatur aspernatur.
                </p>
                <a
                  href="tel:+914742720000"
                  className="btn btn-sm btn-gradient-sg-header px-4 mt-15px rounded-pill fw-600"
                >
                  Navigate
                </a>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
                <div className="mb-15px">
                  <img
                    src={contact_career}
                    className="h-60px -w-100 object-fit-cover"
                    alt=""
                  />
                </div>
                <h5 className="fs-18 fw-bold mb-10px text-dark-gray m-0 lh-sm">
                  Careers
                </h5>
                <p className="fs-14 m-0 lh-base">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga
                  labore pariatur aspernatur.
                </p>
                <a
                  href="tel:+914742720000"
                  className="btn btn-sm btn-gradient-sg-header px-4 mt-15px rounded-pill fw-600"
                >
                  Know more
                </a>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
                <div className="mb-15px">
                  <img
                    src={contact_booking}
                    className="h-60px -w-100 object-fit-cover"
                    alt=""
                  />
                </div>
                <h5 className="fs-18 fw-bold mb-10px text-dark-gray m-0 lh-sm">
                  Book Online Appointment
                </h5>
                <p className="fs-14 m-0 lh-base">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga
                  labore pariatur aspernatur.
                </p>
                <a
                  href="tel:+914742720000"
                  className="btn btn-sm btn-gradient-sg-header px-4 mt-15px rounded-pill fw-600"
                >
                  Book now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white half-section pt-0">
        <div className="container">
          <div className="row -align-items-center -justify-content-center text-start">
            <div
              className="col-xl-6 col-lg-6 md-mb-20px "
              style={{ display: "flex", alignItems: "stretch" }}
            >
              <ScrollAnimation
                animateIn="animate__fadeInLeft"
                animateOnce={true}
                duration={1}
              >
                <img
                  src={why_choose_section_bg}
                  alt=""
                  className="sg-img-radius h-100 object-fit-cover"
                  style={{ height: "100%" }}
                />
              </ScrollAnimation>
            </div>
            <div className="col-xl-6 col-lg-6 md-mb-20px">
              <ScrollAnimation
                animateIn="animate__fadeInRight"
                animateOnce={true}
                duration={1}
              >
                <div className="d-flex gap-3 mb-20px">
                  <div>
                    <img
                      src={quotes}
                      className="w-80px"
                      alt=""
                    />
                  </div>
                  <div>
                    <span className="text-base-color fw-600 -mb-5px text-uppercase d-block fs-12">
                      Contact us
                    </span>
                    <h4 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
                      Send us your{" "}
                      <span className="text-gradient-sg-red-purple">
                        Feedback
                      </span>
                    </h4>
                  </div>
                </div>
                <div className="col-lg-12 align-self-start contact-form-style-03 position-relative">
                  <div className="bg-white box-shadow-double-large p-8 lg-p-8 border-radius-10px">
                    <form onSubmit={handleSubmit(onSubmit)} method="post">
                      {/* Name field with validation */}
                      <div className="position-relative form-group mb-20px">
                        <span className="form-icon text-medium-gray opacity-6">
                          <i className="bi bi-emoji-smile"></i>
                        </span>
                        <input
                          className="ps-0 border-radius-0px bg-transparent border-color-extra-medium-gray form-control"
                          type="text"
                          {...register("name", {
                            required: "Name is required",
                          })}
                          placeholder="Your name"
                        />
                        {errors.name && (
                          <p
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {errors.name.message}
                          </p>
                        )}{" "}
                      </div>

                      {/* Email field with validation */}
                      <div className="position-relative form-group mb-20px">
                        <span className="form-icon medium-gray opacity-6">
                          <i className="bi bi-envelope"></i>
                        </span>
                        <input
                          className="ps-0 border-radius-0px bg-transparent border-color-extra-medium-gray form-control"
                          type="email"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value:
                                /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
                              message: "Invalid email address",
                            },
                          })}
                          placeholder="Your email address"
                        />
                        {errors.email && (
                          <p
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {errors.email.message}
                          </p>
                        )}{" "}
                      </div>

                      {/* Phone field with validation */}
                      <div className="position-relative form-group mb-20px">
                        <span className="form-icon text-medium-gray opacity-6">
                          <i className="bi bi-telephone"></i>
                        </span>
                        <input
                          className="ps-0 border-radius-0px bg-transparent border-color-extra-medium-gray form-control"
                          type="tel"
                          {...register("phone", {
                            required: "Phone number is required",
                          })}
                          placeholder="Your phone"
                        />
                        {errors.phone && (
                          <p
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {errors.phone.message}
                          </p>
                        )}{" "}
                      </div>

                      {/* Message field with validation */}
                      <div className="position-relative form-group form-textarea mt-15px mb-0">
                        <textarea
                          className="ps-0 border-radius-0px bg-transparent border-color-extra-medium-gray form-control"
                          {...register("comment", {
                            required: "Message is required",
                          })}
                          placeholder="Your message"
                          rows="3"
                        ></textarea>
                        <span className="form-icon medium-gray opacity-6">
                          <i className="bi bi-chat-square-dots"></i>
                        </span>
                        {errors.comment && (
                          <p
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {errors.comment.message}
                          </p>
                        )}{" "}
                      </div>

                      <button
                        className="btn btn-medium btn-base-color btn-round-edge mt-35px fw-600"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          "Send message"
                        )}
                      </button>
                    </form>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
          </div>
        </div>
      </section>

      {data && data.latitude && data.longitude ? (
        <section className="bg-white m-0 p-0 overflow-hidden">
          <iframe
            src={`https://www.google.com/maps/embed/v1/place?key=${googleMapsApiKey}&q=${data.latitude},${data.longitude}`}
            width="100%"
            height="600"
            style={{ border: 0, marginBottom: "-10px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </section>
      ) : (
        <section className="bg-white m-0 p-0 overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3943.997151482502!2d76.91143287511106!3d8.691818894175656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b05c150049e49b5%3A0x46313653293c5f73!2sSree%20Gokulam%20Medical%20College%20Hospital!5e0!3m2!1sen!2sin!4v1733401250434!5m2!1sen!2sin"
            width="100%"
            height="600"
            style={{ border: 0, marginBottom: "-10px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </section>
      )}

      <Footer />
      {showToastContainer && <ToastContainer />}
    </>
  );
};

export default ContactUs;

// import React, { useEffect, useRef, useState } from "react";
// import anime from "animejs";
// import HeaderNav from "../HeaderNav";
// import Footer from "../Footer";

// const ContactUs = () => {
//   const titleRef = useRef(null);
//   const cardRef = useRef(null);
//   const imageRef = useRef(null);
// useEffect(() => {
//   // Title animation
// if (titleRef.current) {
//   anime({
//     targets: titleRef.current.children,
//     opacity: [0, 1],
//     translateX: [-30, 0],
//     duration: 800,
//     delay: 0,
//     easing: "easeOutQuad",
//     stagger: 300, // Stagger animation for each child element
//   });
// }

//   // Card animation (for contact boxes)
//   if (cardRef.current) {
//     anime({
//       targets: cardRef.current.children,
//       translateY: [30, 0],
//       opacity: [0, 1],
//       duration: 600,
//       delay: 0,
//       easing: "easeOutQuad",
//       stagger: 300,
//     });
//   }

//   // Image animation
//   if (imageRef.current) {
//     anime({
//       targets: imageRef.current,
//       translateX: [50, 0],
//       opacity: [0, 1],
//       duration: 1200,
//       delay: 0,
//       easing: "easeOutQuad",
//     });
//   }
// }, []);

//   return (
//     <>
//       <HeaderNav />

// <section className="top-space-margin position-relative pt-60px pb-60px page-title-big-typography bg-sg-light-gradient -bg-base-color-light">
//   <img
//     src={logofloating}
//     className="floating-logo"
//     alt="floating-logo"
//   />
//   <div className="container">
//     <div className="row -extra-very-small-screen align-items-center">
//       <div
//         className="col-lg-6 col-sm-8 position-relative page-title-extra-small"
//         ref={titleRef}
//       >
//         <h1 className="mb-20px xs-mb-20px text-dark-gray text-shadow-medium">
//           <span className="w-30px h-2px bg-base-color d-inline-block align-middle position-relative top-minus-2px me-10px"></span>
//           Contact us
//         </h1>
//         <h4 className="text-dark-gray text-shadow-medium fw-bold ls-minus-2px mb-0">
//           Redefining Your{" "}
//           <span className="text-gradient-sg-red-purple ">
//             Healthcare Experience
//           </span>
//         </h4>
//       </div>
//     </div>
//   </div>
// </section>

// <section className="sg-li bg-white half-section">
//   <div className="container">
//     <div
//       className="row justify-content-center gy-4"
//       ref={cardRef} // Reference for the cards animation
//     >
//       <div className="col-md-6 col-lg-4 col-xl-3">
//         <div className="h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
//           <div className="mb-15px">
//             <img
//               src={contact_emergency}
//               className="h-60px -w-100 object-fit-cover"
//               alt=""
//             />
//           </div>
//           <h5 className="fs-18 fw-bold mb-10px text-dark-gray m-0 lh-sm">
//             Emergency Contact
//           </h5>
//           <p className="fs-14 m-0 lh-base">
//             Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga
//             labore pariatur aspernatur.
//           </p>
//           <a
//             href="tel:+914742720000"
//             className="btn btn-sm btn-gradient-sg-header px-4 mt-15px rounded-pill fw-600"
//           >
//             Call now
//           </a>
//         </div>
//       </div>
//       <div className="col-md-6 col-lg-4 col-xl-3">
//         <div className="h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
//           <div className="mb-15px">
//             <img
//               src="../assets/gokulam_images/icons/contact-location.svg"
//               className="h-60px -w-100 object-fit-cover"
//               alt=""
//             />
//           </div>
//           <h5 className="fs-18 fw-bold mb-10px text-dark-gray m-0 lh-sm">
//             Our Location
//           </h5>
//           <p className="fs-14 m-0 lh-base">
//             Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga
//             labore pariatur aspernatur.
//           </p>
//           <a
//             href="tel:+914742720000"
//             className="btn btn-sm btn-gradient-sg-header px-4 mt-15px rounded-pill fw-600"
//           >
//             Navigate
//           </a>
//         </div>
//       </div>
//       <div className="col-md-6 col-lg-4 col-xl-3">
//         <div className="h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
//           <div className="mb-15px">
//             <img
//               src={contact_career}
//               className="h-60px -w-100 object-fit-cover"
//               alt=""
//             />
//           </div>
//           <h5 className="fs-18 fw-bold mb-10px text-dark-gray m-0 lh-sm">
//             Careers
//           </h5>
//           <p className="fs-14 m-0 lh-base">
//             Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga
//             labore pariatur aspernatur.
//           </p>
//           <a
//             href="tel:+914742720000"
//             className="btn btn-sm btn-gradient-sg-header px-4 mt-15px rounded-pill fw-600"
//           >
//             Know more
//           </a>
//         </div>
//       </div>
//       <div className="col-md-6 col-lg-4 col-xl-3">
//         <div className="h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
//           <div className="mb-15px">
//             <img
//               src={contact_booking}
//               className="h-60px -w-100 object-fit-cover"
//               alt=""
//             />
//           </div>
//           <h5 className="fs-18 fw-bold mb-10px text-dark-gray m-0 lh-sm">
//             Book Online Appointment
//           </h5>
//           <p className="fs-14 m-0 lh-base">
//             Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga
//             labore pariatur aspernatur.
//           </p>
//           <a
//             href="tel:+914742720000"
//             className="btn btn-sm btn-gradient-sg-header px-4 mt-15px rounded-pill fw-600"
//           >
//             Book now
//           </a>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>

//       <section className="bg-white half-section pt-0">
//         <div className="container">
//           <div className="row -align-items-center -justify-content-center text-start">
//             <div className="col-xl-6 col-lg-6 md-mb-20px" ref={imageRef}>
//               <img
//                 src={why_choose_section_bg}
//                 alt=""
//                 className="sg-img-radius h-100 object-fit-cover"
//               />
//             </div>
//             <div className="col-xl-6 col-lg-6 md-mb-20px">
//               <div className="d-flex gap-3 mb-20px">
//                 <div>
//                   <img
//                     src="../assets/gokulam_images/icons/quotes.png"
//                     className="w-80px"
//                     alt=""
//                   />
//                 </div>
//                 <div>
//                   <span className="text-base-color fw-600 -mb-5px text-uppercase d-block fs-12">
//                     Contact us
//                   </span>
//                   <h4 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
//                     Send us your{" "}
//                     <span className="text-gradient-sg-red-purple">
//                       Feedback
//                     </span>
//                   </h4>
//                 </div>
//               </div>
//               <div className="col-lg-12 align-self-start contact-form-style-03 position-relative">
//                 <div className="bg-white box-shadow-double-large p-8 lg-p-8 border-radius-10px">
//                   <form method="post">
//                     <div className="position-relative form-group mb-20px">
//                       <span className="form-icon text-medium-gray opacity-6">
//                         <i className="bi bi-emoji-smile"></i>
//                       </span>
//                       <input
//                         className="ps-0 border-radius-0px bg-transparent border-color-extra-medium-gray form-control required"
//                         type="text"
//                         name="name"
//                         placeholder="Your name*"
//                       />
//                     </div>
//                     <div className="position-relative form-group mb-20px">
//                       <span className="form-icon medium-gray opacity-6">
//                         <i className="bi bi-envelope"></i>
//                       </span>
//                       <input
//                         className="ps-0 border-radius-0px bg-transparent border-color-extra-medium-gray form-control required"
//                         type="email"
//                         name="email"
//                         placeholder="Your email address*"
//                       />
//                     </div>
//                     <div className="position-relative form-group mb-20px">
//                       <span className="form-icon text-medium-gray opacity-6">
//                         <i className="bi bi-telephone"></i>
//                       </span>
//                       <input
//                         className="ps-0 border-radius-0px bg-transparent border-color-extra-medium-gray form-control"
//                         type="tel"
//                         name="phone"
//                         placeholder="Your phone"
//                       />
//                     </div>
//                     <div className="position-relative form-group form-textarea mt-15px mb-0">
//                       <textarea
//                         className="ps-0 border-radius-0px bg-transparent border-color-extra-medium-gray form-control"
//                         name="comment"
//                         placeholder="Your message"
//                         rows="3"
//                       ></textarea>
//                       <span className="form-icon medium-gray opacity-6">
//                         <i className="bi bi-chat-square-dots"></i>
//                       </span>
//                       <input type="hidden" name="redirect" value="" />
//                       <button
//                         className="btn btn-medium btn-base-color btn-round-edge mt-35px submit fw-600"
//                         type="submit"
//                       >
//                         Send message
//                       </button>
//                       <div className="form-results mt-20px d-none"></div>
//                     </div>
//                   </form>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="bg-white m-0 p-0 overflow-hidden">
//         <iframe
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3943.997151482502!2d76.91143287511106!3d8.691818894175656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b05c150049e49b5%3A0x46313653293c5f73!2sSree%20Gokulam%20Medical%20College%20Hospital!5e0!3m2!1sen!2sin!4v1733401250434!5m2!1sen!2sin"
//           width="100%"
//           height="600"
//           style={{ border: 0, marginBottom: "-10px" }}
//           allowFullScreen=""
//           loading="lazy"
//           referrerPolicy="no-referrer-when-downgrade"
//         ></iframe>
//       </section>

//       <Footer />

//     </>
//   );
// };

// export default ContactUs;
